import { render, staticRenderFns } from "./clin-trans-customer-list.vue?vue&type=template&id=40481aa0&scoped=true"
import script from "./clin-trans-customer-list.vue?vue&type=script&lang=js"
export * from "./clin-trans-customer-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40481aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40481aa0')) {
      api.createRecord('40481aa0', component.options)
    } else {
      api.reload('40481aa0', component.options)
    }
    module.hot.accept("./clin-trans-customer-list.vue?vue&type=template&id=40481aa0&scoped=true", function () {
      api.rerender('40481aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/admin/clin-trans-customer-list.vue"
export default component.exports